import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import chart from './modules/chart'
import user from './modules/user'
import table from './modules/table'
import measurements from './modules/measurements'
import customers from './modules/customers'
import components from './modules/components'
import componenttypes from './modules/componenttypes'
import brands from './modules/brands'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    reducer: (state) => ({auth: state.auth})
})

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        chart,
        user,
        measurements,
        table,
        customers,
        components,
        componenttypes,
        brands
    },
    plugins: [vuexLocal.plugin]
})
